import React, { useEffect, useState } from 'react';
import { Stack } from '@atlaskit/primitives';

interface WithOnCloseProps {
  onClose: () => void;
}

interface Props extends WithOnCloseProps {
  success: React.ComponentType<WithOnCloseProps>;
  warning: React.ComponentType<WithOnCloseProps>;
}

const SuccessWithWarning: React.FC<Props> = ({ success: Success, warning: Warning, onClose }) => {
  const [successIsVisible, setSuccessIsVisible] = useState(true);
  const [warningIsVisible, setWarningIsVisible] = useState(true);

  useEffect(() => {
    if (!successIsVisible && !warningIsVisible) {
      onClose();
    }
  }, [successIsVisible, warningIsVisible]);

  return (
    <Stack space='space.100'>
      {successIsVisible && <Success onClose={() => setSuccessIsVisible(false)} />}
      {warningIsVisible && <Warning onClose={() => setWarningIsVisible(false)} />}
    </Stack>
  );
};

export default SuccessWithWarning;
